"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClientTypeOptions = exports.ClientTypeDescriptions = exports.ClientType = void 0;
var ClientType;
(function (ClientType) {
    ClientType[ClientType["active"] = 0] = "active";
    ClientType[ClientType["paused"] = 1] = "paused";
    ClientType[ClientType["pastDue"] = 2] = "pastDue";
    ClientType[ClientType["lead"] = 3] = "lead";
    ClientType[ClientType["archived"] = 4] = "archived";
    // not used  yet, but probably will be
    ClientType[ClientType["free"] = 5] = "free";
    ClientType[ClientType["appSub0"] = 6] = "appSub0";
    ClientType[ClientType["appSub1"] = 7] = "appSub1";
    ClientType[ClientType["appSub2"] = 8] = "appSub2";
})(ClientType = exports.ClientType || (exports.ClientType = {}));
exports.ClientTypeDescriptions = {
    // this is really only used in filter buttons/selectors
    [-1]: 'all',
    [ClientType.active]: 'active',
    [ClientType.pastDue]: 'past due',
    [ClientType.lead]: 'lead',
    [ClientType.paused]: 'paused',
    [ClientType.archived]: 'archived',
    [ClientType.free]: 'free',
    [ClientType.appSub0]: 'app sub level 0',
    [ClientType.appSub1]: 'app sub level 1',
    [ClientType.appSub2]: 'app sub level 2',
};
exports.ClientTypeOptions = [
    { value: ClientType.active, description: 'Active' },
    { value: ClientType.paused, description: 'Paused' },
    //{ value: ClientType.pastDue, description: 'Past Due'},
    { value: ClientType.lead, description: 'Lead' },
    { value: ClientType.free, description: 'App subscriber, free level' },
    { value: ClientType.appSub0, description: 'App subscriber, level 0' },
    { value: ClientType.appSub1, description: 'App subscriber, level 1' },
    { value: ClientType.appSub2, description: 'App subscriber, level 2' },
];
//# sourceMappingURL=Client.js.map